import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'

import initBugsnag from '@/helpers/initBugsnag'
import { createJwxI18n } from '@/i18n'

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
const app = createApp(App);
const bugsnagVue = initBugsnag('Ops Console - StormCenter')

app.use(pinia);
app.use(bugsnagVue)
// Localization is rolled out to the complete-report webview only for now:
// pinned to English here (?lang= still works as a manual QA override).
app.use(createJwxI18n())
app.mount('#storm-center');